module.exports = __webpack_public_path__ + "static/media/aero.4e6117b4.png";